/**
 * @Description 点位详情的已分析的拍摄任务的客流分析折线图（合并）
 */

import { FC, useEffect, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { doWeight, isArray } from '@lhb/func';
import { taskSpotLines } from '@/common/api/passengerflowcount';
// import { demoData } from '../../ts-config';
// import cs from 'classnames';
import styles from './index.module.less';
import V2LineChart from '@/common/components/Charts/V2LineChart';

const SpotLines: FC<{
  /** 点位id */
   id,
}> = ({
  id, // 点位id
}) => {
  const [xAxisDataLine, setXAxisDataLine] = useState<Array<string>>([]);
  const [seriesDataLine, setSeriesDataLine] = useState<any[]>([]);

  useEffect(() => {
    if (+id) {
      methods.loadData();
    }
  }, [id]);

  const methods = useMethods({
    loadData: async () => {
      const params = {
        id
      };
      const { lines } = await taskSpotLines(params);
      if (!(isArray(lines) && lines.length > 0)) return;
      // const demoDatas = demoData || lines;
      // https://confluence.lanhanba.com/pages/viewpage.action?pageId=119164524 取最近的5个，拍摄时长大于6小时服务端已经过滤了
      const targetLines = lines.filter((item: any, index: number) => index < 5);
      // x轴显示的时间段，合并数组，然后去重
      const xAllData: any[] = [];
      const countMap: any = {}; // 收集name出现的次数
      targetLines.forEach((item: any) => {
        const { points, name } = item;
        countMap[name] = { // name为key
          value: (countMap[name]?.value || 0) + 1, // 用来记录递减
          index: 0, // 用来记录重复的次数
          count: (countMap[name]?.value || 0) + 1, // 出现的总次数
        };
        points?.forEach((pointItem: any) => {
          xAllData.push(pointItem.name);
        });
      });

      // 先去重
      const uniqueXAllData = doWeight(xAllData);
      // '11:00-11:30', '11:12-11:30',  排序
      const sortXAllData = uniqueXAllData?.sort((a, b) => {
        const aHM = a.split('-'); // ['11:00', '11:30']
        const aHMArr = aHM?.[0]?.split(':'); // ['11', '00']
        const aH = aHMArr?.[0]; // 11
        const aM = aHMArr?.[1]; // 00

        const bHM = b.split('-'); // ['11:12', '11:30']
        const bHMArr = bHM?.[0]?.split(':'); // ['11' , '12']
        const bH = bHMArr?.[0];
        const bM = bHMArr?.[1];
        const aVal = +(`${aH || 0}.${aM || 0}`);
        const bVal = +(`${bH || 0}.${bM || 0}`);
        return aVal - bVal;
      });
      // console.log(`sortXAllData`, sortXAllData);
      setXAxisDataLine(isArray(sortXAllData) ? sortXAllData : []);
      // 抹平不同任务下points长度不同时，x轴显示的问题
      const seriesData: any[] = [];
      targetLines.forEach((itemLine: any) => {
        const { name, points } = itemLine;
        const data: any = [];
        sortXAllData?.forEach((xItem: any) => {
          const targetVal = points?.find((pointItem: any) => xItem === pointItem.name)?.value;
          data.push(+targetVal ? +targetVal : 0);
        });
        let showName = name;
        // 如果拍摄任务重名，后面拼接出现的次数，如果不处理，echarts内部会合并同名的
        if (countMap[name].count > 1) { // 说明有多个同名
          showName = `${name} (${countMap[name].index + 1})`;
          countMap[name].index++;
          countMap[name].value--;
        }
        seriesData.push({
          name: showName,
          unit: '',
          data,
        });
      });
      setSeriesDataLine(seriesData);
    }
  });
  return <>
    {
      xAxisDataLine?.length > 0 ? <div className={styles.timeChartsWrap}>
        <V2LineChart
          resizable
          title='客流趋势图'
          xAxisData={xAxisDataLine}
          seriesData={seriesDataLine}
          config={{
            legend: {
              right: 15,
            },
            grid: {
              right: 40
            }
          }}
        />
      </div> : <></>
    }
  </>;
};

export default SpotLines;
